import styles from './tags.component.module.scss';

type Props = {
  skills: {
    id: number;
    name: string;
    isMatched?: boolean;
  }[];
};

export const Tags = ({ skills }: Props) => (
  <ul className={styles.tagList}>
    {skills.map((skill) => (
      <li
        className={`${skill.isMatched ? 'match' : ''} ${styles.tagListItem}`}
        data-match={skill.isMatched ? true : undefined}
        key={skill.id}
      >
        {skill.name}
      </li>
    ))}
  </ul>
);
